var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0623 6.79424C12.2664 6.5902 12.2664 6.2594 12.0623 6.05537C11.8583 5.85134 11.5275 5.85134 11.3234 6.05537L9.22999 8.14883L7.13653 6.05537C6.9325 5.85134 6.60169 5.85134 6.39766 6.05537C6.19363 6.2594 6.19363 6.59021 6.39766 6.79424L8.49112 8.8877L6.39765 10.9812C6.19362 11.1852 6.19362 11.516 6.39765 11.72C6.60169 11.9241 6.93249 11.9241 7.13652 11.72L9.22999 9.62657L11.3235 11.72C11.5275 11.9241 11.8583 11.9241 12.0623 11.72C12.2664 11.516 12.2664 11.1852 12.0623 10.9812L9.96886 8.8877L12.0623 6.79424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCross);
export default __webpack_public_path__ + "static/media/White_Cross.64ff579c3bdca718f81ed6c13e0adcb4.svg";
export { ForwardRef as ReactComponent };